import { useNavigate } from 'react-router-dom'
import React from 'react'
import axios from 'axios'

const Indexx = () => {
    const navigate = useNavigate()

    const register=async(e)=>{
        e.preventDefault()
        const fdata = new FormData(e.currentTarget)
        const adata = {
            email:fdata.get("email"),
            password:fdata.get("password"),
            name:fdata.get("name")
        }
        // console.log(adata)
        const r = await axios.post("https://whatsappbac.vercel.app/register", adata)
        // console.log(r.data)
        navigate("/verify", {state: r.data})
    }
    const login=async(e)=>{
        e.preventDefault()
        const fdata = new FormData(e.currentTarget)
        const adata = {
            email:fdata.get("email"),
            password:fdata.get("password"),
        }
        // console.log(adata)
        const r = await axios.post("https://whatsappbac.vercel.app/userlogin", adata)
        navigate("/home", {state: r.data})

    }
  return (
    <>
     <div>
        <div className='container'>
            <h1 style={{backgroundColor:"red", color:"white", padding:"5px"}}>Chit-Chat</h1>
            <div className=' list-group' style={{marginTop:"12%", marginLeft:"5%"}}>
                <div  className='list-group-item' >
                    <h3>Login In</h3>
                    <form onSubmit={login}>
                        <input type="email" name="email" placeholder='email' required  />
                        <input type="password" name="password" placeholder='password' required /> <br/>
                        <button className='btn btn-danger' type="submit">Login</button>
                        <small className='ms-5'>Dummy:- raj@gmail.com | 12345</small>
                    </form>
                </div>
                <div className='list-group-item'  style={{marginLeft:"10%"}}>
                    <h3>Register</h3>
                    <form onSubmit={register}>
                        <input type="email" name="email" placeholder='email' required  />
                        <input type="password" name="password" placeholder='password' required /> <br/>
                        <input type="text" name="name" placeholder='name' required />
                        <button className='btn btn-danger' type="submit">Register</button>
                    </form>
                    
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Indexx